export enum Clip {
  none,
  hardEdge,
  antiAlias,
  antiAliasWithSaveLayer,
}
